export default "__VITE_ASSET__DTTiZWem__"